import { render, staticRenderFns } from "./ParentingPriorityStep.vue?vue&type=template&id=eed97ddc"
import script from "./ParentingPriorityStep.vue?vue&type=script&lang=ts"
export * from "./ParentingPriorityStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports